import styled from 'styled-components';
import { prefix } from '../../../tools/settings';
import IconButton from '../../IconButton';
var Navigation = styled.div.withConfig({
  displayName: "Controlsstyles__Navigation",
  componentId: "sc-1xtebwb-0"
})([""]);
var NextButton = styled(IconButton).withConfig({
  displayName: "Controlsstyles__NextButton",
  componentId: "sc-1xtebwb-1"
})(["position:absolute;z-index:1;right:var(--dentsu-spacing-24);top:50%;margin-top:", ";"], function (props) {
  return props.hasPaging ? '-36px' : '-22px';
});
var PrevButton = styled(IconButton).withConfig({
  displayName: "Controlsstyles__PrevButton",
  componentId: "sc-1xtebwb-2"
})(["position:absolute;z-index:1;left:var(--dentsu-spacing-24);top:50%;margin-top:", ";"], function (props) {
  return props.hasPaging ? '-36px' : '-22px';
});
var PagingDots = styled.div.withConfig({
  displayName: "Controlsstyles__PagingDots",
  componentId: "sc-1xtebwb-3"
})(["position:relative;display:flex;align-items:center;justify-content:center;padding:var(--dentsu-spacing-16);"]);
var Dot = styled.button.withConfig({
  displayName: "Controlsstyles__Dot",
  componentId: "sc-1xtebwb-4"
})(["border:2px solid var(--dentsu-color-b550);border-radius:50%;background:var(--dentsu-color-b550);margin:0 var(--dentsu-spacing-2);padding:0;width:12px;height:12px;outline:0 none;&:hover{cursor:pointer;}&.", "-carousel__pagingDot--isActive{background:var(--dentsu-color-white);}"], prefix);
export var Styled = {
  Navigation: Navigation,
  NextButton: NextButton,
  PrevButton: PrevButton,
  PagingDots: PagingDots,
  Dot: Dot
};